module.exports = __webpack_public_path__ + "static/media/emi.3932bf47.svg";